import { render, staticRenderFns } from "./DialogLanguage.vue?vue&type=template&id=02c33b40&"
import script from "./DialogLanguage.vue?vue&type=script&lang=js&"
export * from "./DialogLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports